import React from 'react';

import Schedule from '../../snippets/Schedule';

class SessionsPage extends React.Component {
  componentDidMount() {
    // this.props.getFilms()
  }
  render() {
    return (
      <div className="sess">
        <Schedule
          heading="Сеанси"
          showDates={true}
          films={this.props.films}
          dates={this.props.dates}
          halls={this.props.halls}
          formats={this.props.formats}
          hallsById={this.props.hallsById}
          formatsById={this.props.formatsById}
          showHallFilter={true}
          showFormatFilter={true}
          handleSessionClick={this.props.handleSessionClick}
          cssDesktopClassForPage='session-page'
        />
      </div>
    )
  }
}

export default SessionsPage


// WEBPACK FOOTER //
// ./src/components/pages/SessionsPage/SessionsPageWrapper.jsx